import { render, staticRenderFns } from "./SpecificExtraWorkManagementDetails.vue?vue&type=template&id=57b1cca2&scoped=true&"
import script from "./SpecificExtraWorkManagementDetails.vue?vue&type=script&lang=js&"
export * from "./SpecificExtraWorkManagementDetails.vue?vue&type=script&lang=js&"
import style0 from "./SpecificExtraWorkManagementDetails.vue?vue&type=style&index=0&id=57b1cca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b1cca2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCol,VDialog,VRow,VSpacer})
